/* @flow */
/**
 * Created by Ondra on 14.10.2016.
 */
import React from 'react';
import {connect} from 'react-redux';
import {payBarReportShift} from '../../../../common/menu/report/shifts/actions';
import {showPopupInMenu} from '../../../../common/menu/actions';

class CashPopup extends React.Component {

    static propTypes = {
        msg: React.PropTypes.object,
        cashboxes: React.PropTypes.object,
        shift: React.PropTypes.object,
        payBarReportShift: React.PropTypes.func,
        showPopupInMenu: React.PropTypes.func
    };

    constructor(props) {
        super(props);

        this.payOff = this.payOff.bind(this);
    }

    payOff(cashboxId) {
        const {shift, payBarReportShift, showPopupInMenu} = this.props;
        payBarReportShift(cashboxId, shift.get('id'));
        showPopupInMenu(false);
    }

    render() {
        const {cashboxes, msg} = this.props;

        return (
            <div className="popup-inner">
                <h1 className="popup-title">{msg.shifts.payFromCashbox}</h1>
                <div className="popup-list">
                    {!!cashboxes && cashboxes.filter(c => c.get('type') === 'CASH' && c.getIn(['currency', 'name']) === 'CZK').map(c =>
                      <div className="popup-list-key"
                           key={`cashbox-${c.get('id')}`}>
                        <div className="boxBtn color-white"
                             onClick={() => this.payOff(c.get('id'))}>
                            <div className="boxBtn-inner">
                                <span>
                                    {c.get('name')}
                                </span>
                            </div>
                        </div>
                      </div>
                    )}
                </div>
            </div>
        );
    }
}

export default connect(state => ({
    msg: state.intl.trans[state.intl.currentLocale],
    cashboxes: state.cashboxes.get('cashboxes'),
    shift: state.shifts.get('shift')
}), {payBarReportShift, showPopupInMenu})(CashPopup);



// WEBPACK FOOTER //
// ./src/browser/menu/report/shifts/CashPopup.js